import { Component, OnInit } from '@angular/core';

import { Bulk2ServicesService } from 'src/app/core/api/services';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { SimType, SmsAggregator } from '../../../../core/api/models';
import { GenderType } from '../../../../core/api/models/gender-type';
import { NumberDto } from '../../../../core/api/models/number-dto';
import { BulkNumberInformationFormComponent } from '../../bulk-number-information/bulk-number-information-form/bulk-number-information-form.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';

@Component({
  selector: 'app-bulk-number-information2-form',
  templateUrl: './bulk-number-information2-form.component.html',
  imports: [BaseFormModule],
})
export class BulkNumberInformation2FormComponent
  extends BulkNumberInformationFormComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<NumberDto> = {};

  //#region Enums
  get GenderType() {
    return GenderType;
  }
  get SmsAggregator() {
    return SmsAggregator;
  }
  get SimType() {
    return SimType;
  }

  //zones
  selectedState;
  selectedCountry = 1;
  selectedGuild = 1;
  //#endregion

  constructor(public current2Service: Bulk2ServicesService) {
    super();
  }

  //#region Api
}
